import "./TemplateRequirementSelector.less";

import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";

import { colorList } from "lib/colors";
import { IBaseProps } from "lib/data/interfaces";
import { Requirement, RequirementItem } from "lib/data/model";
import { ComponentTemplate } from "lib/data/model";
import { SectionTemplate } from "lib/data/model";
import { MultipleItemRequirement } from "lib/data/model";
import { SingleItemRequirement } from "lib/data/model";
import { ComponentNames } from "lib/data/model/dictionaries/ComponentNames";
import { IconType } from "lib/data/model/dictionaries/IconTypes";
import { Requiredness } from "lib/data/model/enumerations";

import { TemplateCard } from "components/general";
import { actionTypes } from "components/general/TemplateCard/ActionTypes";
import { SortableItem } from "./SortableItem";

interface Map<T> {
	[K: string]: T;
}

interface MatchProps {
	id: string;
}

interface ITemplateRequirementSelectorProps extends IBaseProps, RouteComponentProps<MatchProps> {
	templateRequirementList: Array<RequirementItem<ComponentTemplate>>;
	genericComponentTemplates: ComponentTemplate[];
	sectionTemplate: SectionTemplate;
	softSectionTemplateUpdate: () => void;
	hardSectionTemplateUpdate: (callback: () => void) => void;
	onTemplateEdit: (multipleItemRequirement: MultipleItemRequirement<ComponentTemplate>) => void;
	onTemplateDelete: (multipleItemRequirement: Requirement) => void;
	loading: boolean;
}

type modalTypes = "newSingleItem" | "newMultiItem" | "editMultiItem" | "hidden";
interface ITemplateRequirementSelectorState {
	modalSelected: modalTypes;
	multipleItemRequirement: MultipleItemRequirement<ComponentTemplate> | undefined;
	newSections: [];
}

// can handle up to 81 different color requirments without repeating a color


const BASE_URL = "/admin/templateHierarchy";

class TemplateRequirementSelectorPreRouter extends React.Component<ITemplateRequirementSelectorProps, ITemplateRequirementSelectorState> {
	constructor(props: ITemplateRequirementSelectorProps) {
		super(props);
		this.state = {
			modalSelected: "hidden",
			newSections: [],
			multipleItemRequirement: undefined
		};
	}

	public render() {
		// const breadcrumb = (<Breadcrumb separator=">">
		//     {this.props.itemHierarchy.map((item, key) => <Breadcrumb.Item key={key}>{item}</Breadcrumb.Item>)}
		// </Breadcrumb>);
		return (
			this.renderTemplateData()
		);

		/* <GradientBar
            styleOverride="flibidigibit"
            subTitle={breadcrumb}
            title={this.props.itemHierarchy[this.props.itemHierarchy.length - 1]}
            className="template-hierarchy-breadcrumb" />
*/


	}

	private onSectionTemplateExpand = (id: number): void => {
		this.props.history.push(`${BASE_URL}/${id}`);
	}

	private onEntryGroupTemplateExpand = (id: number): void => {
		const sectionId = this.props.match.params.id;
		this.props.history.push(`${BASE_URL}/${sectionId}/entryGroupTemplate/${id}`);
	}

	private onListingGroupTemplateExpand = (id: number): void => {
		const sectionId = this.props.match.params.id;
		this.props.history.push(`${BASE_URL}/${sectionId}/listingGroupTemplate/${id}`);
	}

	private actionClickHandler = (command: actionTypes, index?: number) => {
		if (index === undefined) {
			return;
		}
		// Grab Item out of the requirement items
		const singleItemRequirementItem = this.props.templateRequirementList[index];
		// Command switch
		switch (command) {
			case "delete":
				// Remove Requirement from requirements list
				this.props.sectionTemplate.requirements = this.props.sectionTemplate.requirements.filter((requirement) => requirement.id !== singleItemRequirementItem.owningRequirement.id);
				// Remove Requirement Item from requirement list
				this.props.sectionTemplate.templateRequirementList = this.props.sectionTemplate.templateRequirementList.filter((requirement) => requirement.id !== singleItemRequirementItem.id);
				// Update psudo state and send off api call to update
				this.props.softSectionTemplateUpdate();
				break;
			case "expand":
				// verify the id is set on the requirement item
				if (singleItemRequirementItem.item.id) {
					// choose the correct function for the given case
					switch (singleItemRequirementItem.item.$type) {
						case "SectionTemplate":
							this.onSectionTemplateExpand(singleItemRequirementItem.item.id);
							break;
						// TODO add in listing group and entry group On clicks
						case "ListingGroupTemplate":
							this.onListingGroupTemplateExpand(singleItemRequirementItem.item.id);
							break;
						case "EntryGroupTemplate":
							this.onEntryGroupTemplateExpand(singleItemRequirementItem.item.id);
							break;
						default:
							break;
					}

				}
				break;
			default:
				break;
		}
	}

	private multiItemActionClickHandler = async (command: actionTypes, index: number, multipleItemRequirement: MultipleItemRequirement<ComponentTemplate> | null) => {
		if (multipleItemRequirement) {
			switch (command) {
				case "edit":
					this.props.onTemplateEdit(multipleItemRequirement);
					return;
				case "delete":
					this.props.onTemplateDelete(multipleItemRequirement);
					break;
				case "expand":
					// verify the id is set on the requirement item
					if (index !== null) {
						// choose the correct function for the given case
						const singleItemRequirementItem = this.props.templateRequirementList[index];
						if (singleItemRequirementItem.item.id) {
							switch (singleItemRequirementItem.item.$type) {
								case "SectionTemplate":
									this.onSectionTemplateExpand(singleItemRequirementItem.item.id);
									break;
								// TODO add in listing group and entry group On clicks
								case "ListingGroupTemplate":
									this.onListingGroupTemplateExpand(singleItemRequirementItem.item.id);
									break;
								case "EntryGroupTemplate":
									this.onEntryGroupTemplateExpand(singleItemRequirementItem.item.id);
									break;
								default:
									break;
							}
						}
					}

					break;
				default:
					break;

			}
		}
	}

	private updateSectionTitle = (newTitle: string, callback: (() => void) | undefined, key: number) => {

		this.props.templateRequirementList[key].item.name = newTitle;

		if (callback !== undefined) {

			this.props.hardSectionTemplateUpdate(callback);
		}
	}

	private getComponentActionButtons = (requirement: RequirementItem<ComponentTemplate>) => {

		const actionbuttons: actionTypes[] = ["delete"];

		if (requirement.owningRequirement.$type === MultipleItemRequirement.$type.ComponentTemplate) {
			actionbuttons.push("edit");
		}

		switch (requirement.item.$type) {
			case "SectionTemplate":
				actionbuttons.push("expand");
				break;
			// TODO add in listing group and entry group On clicks
			case "ListingGroupTemplate":
				actionbuttons.push("expand");
				break;
			case "EntryGroupTemplate":
				actionbuttons.push("expand");
				break;

			default:
				break;
		}


		return actionbuttons;
	}

	private renderTemplateData = () => {
		// establish the id for selecting a color(starts at -0)
		let colorIndex = -1;

		const currentMultiItemIds: Map<string> = {};

		// map out all the items
		return (
			this.props.templateRequirementList.map((requirement, key) => {
				// if the current item is a multiItemRequirement and that requirement is not already in the dictornary
				let multiItem: MultipleItemRequirement<ComponentTemplate> | null = null;

				if (requirement.owningRequirement.$type === MultipleItemRequirement.$type.ComponentTemplate) {
					multiItem = requirement.owningRequirement as MultipleItemRequirement<ComponentTemplate>;
					if (multiItem.id !== undefined) {
						if (!currentMultiItemIds[multiItem.id]) {
							if (colorIndex === 81) {
								colorIndex = 0;
							} else {
								colorIndex++;
							}
							// iterate the next to the next color
							// create a new dictonary entry with the new requirment id and the colorIndex in the colorList
							currentMultiItemIds[multiItem.id] = colorList[(multiItem.id % colorList.length) - 1];
							// If you have gone through the 81 colors, start the new colors back at 0
						}
					}
				}




				// now that we have defined the next color create the template card
				if (multiItem && requirement.id) {
					if (multiItem.id) {
						const actionbuttons = this.getComponentActionButtons(requirement);
						return (
							<SortableItem key={`item-${key}`} index={key}>
								<TemplateCard
									canEditTitle={true}
									updateTitle={(newTitle: string, callback?: () => void) => this.updateSectionTitle(newTitle, callback, key)}
									onCheckboxclick={this.props.softSectionTemplateUpdate}
									key={requirement.id}
									requirement={requirement}
									id={requirement.id}
									multiRequirementColor={currentMultiItemIds[multiItem.id]}
									multiItemRequirementId={multiItem.id || undefined}
									actionbuttons={actionbuttons}
									actionButtonClick={(command: actionTypes) => { this.multiItemActionClickHandler(command, key, multiItem); }}
									showCheckboxes={true}
									title={requirement.item.name}
									iconType={IconType.get(requirement.item.$type)}
									templateType={ComponentNames[requirement.item.$type]}
								/>
							</SortableItem >
						);
					}
				}
				else {
					if (requirement.id) {
						const actionbuttons = this.getComponentActionButtons(requirement);
						return (
							<SortableItem key={`item-${key}`} index={key}>
								<TemplateCard
									canEditTitle={true}
									updateTitle={(newTitle: string, callback?: () => void) => this.updateSectionTitle(newTitle, callback, key)}
									onCheckboxclick={this.props.softSectionTemplateUpdate}
									key={requirement.id}
									requirement={requirement}
									id={requirement.id}
									actionbuttons={actionbuttons}
									actionButtonClick={(command: actionTypes) => { this.actionClickHandler(command, key); }}
									showCheckboxes={true}
									required={requirement.owningRequirement.requiredness === Requiredness.REQUIRED}
									repeatable={(
										requirement.owningRequirement.$type === SingleItemRequirement.$type.ComponentTemplate
											?
											(requirement.owningRequirement as SingleItemRequirement<ComponentTemplate>).isRepeatable
											:
											undefined
									)}
									title={requirement.item.name}
									iconType={IconType.get(requirement.item.$type)}
									templateType={ComponentNames[requirement.item.$type]}
								/>
							</SortableItem >
						);
					}
				}

			})
		);
	}
}

export const TemplateRequirementSelector = withRouter(TemplateRequirementSelectorPreRouter);
